// DimmedLayerBadge — キャンバス隅の札「うすく表示中 (じぶんだけ)」
// (docs/_wip/layer-display-opacity-2026-10-12.md)。1 枚でも 100% 未満のときだけ出る。
// 押すと全層 100% に戻る。描く層(アクティブ)が薄いときは色を変えて強調する
// (「消しゴムが効かない?」の混乱を減らす)。再接続帯 (下端・黄) とは位置も色も分ける。

export interface DimmedLayerBadgeProps {
  /** index = layerId。 */
  readonly opacities: readonly number[];
  readonly activeLayerId: number;
  readonly onReset: () => void;
}

export const DimmedLayerBadge = ({
  opacities,
  activeLayerId,
  onReset,
}: DimmedLayerBadgeProps): React.ReactNode => {
  if (!opacities.some((v) => v < 1)) return null;
  const activeDimmed = (opacities[activeLayerId] ?? 1) < 1;
  return (
    <button
      type="button"
      data-testid="dimmed-layer-badge"
      data-active-dimmed={activeDimmed ? 'true' : 'false'}
      onClick={onReset}
      title="押すとぜんぶふつうの濃さに戻ります"
      aria-label={
        activeDimmed
          ? 'うすく表示中 (じぶんだけ)。いま描く層もうすい。押すとふつうの濃さに戻ります'
          : 'うすく表示中 (じぶんだけ)。押すとふつうの濃さに戻ります'
      }
      className={`absolute left-2 top-2 z-10 rounded-full border px-3 py-1 text-xs font-bold shadow ${
        activeDimmed
          ? 'border-[var(--color-canvas-frame)] bg-white text-[var(--color-error)]'
          : 'border-[var(--color-border)] bg-[var(--color-bg-inset)] text-[var(--color-text-muted)]'
      }`}
    >
      うすく表示中 (じぶんだけ)
    </button>
  );
};
